'use client';

export const ArrowRight = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M23.8795 16.9591H5.94105C5.66969 16.9591 5.445 16.8687 5.267 16.6881C5.089 16.5077 5 16.2802 5 16.0054C5 15.7305 5.089 15.5028 5.267 15.3224C5.445 15.142 5.66969 15.0518 5.94105 15.0518H23.8795L15.5639 6.63557C15.3847 6.44609 15.2924 6.22435 15.2872 5.97036C15.2817 5.71637 15.3766 5.49185 15.5718 5.2968C15.767 5.1015 15.9878 5.00259 16.2342 5.00006C16.4806 4.99728 16.7015 5.0948 16.8967 5.29263L26.6495 15.1755C26.7716 15.2995 26.8606 15.4286 26.9165 15.563C26.9722 15.6976 27 15.8454 27 16.0066C27 16.168 26.9722 16.3155 26.9165 16.449C26.8606 16.5826 26.7716 16.7114 26.6495 16.8353L16.8967 26.7183C16.7162 26.9012 16.4997 26.995 16.2473 26.9998C15.9947 27.0046 15.7695 26.9108 15.5718 26.7183C15.3766 26.5176 15.2789 26.2919 15.2789 26.0409C15.2789 25.7899 15.3766 25.5687 15.5718 25.3772L23.8795 16.9591Z"
				fill="currentColor"
			/>
		</svg>
	);
};
